var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('van-loading',{attrs:{"type":"spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }